var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$page.props.app.env !== 'production')?_c('div',{staticClass:"env-label"},[_vm._v("\n    "+_vm._s(_vm.$page.props.app.env)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }